//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetItemName, GetItemSkinName } from "@/tool";

export default {
  name: "BoxLotteryH",
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isTransition: {
      type: Boolean,
      default: true,
    },
    // 是默认的原来的，新的需求自定义
    isDefalut: {
      type: Boolean,
      default: true,
    },
    award_opened_show: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    GetItemName,
    GetItemSkinName,
  },
  data() {
    return {
      run_status: 0,
      virtual_case_awards: [],
      animation_end: false,
    };
  },
  computed: {
    /** 乱序奖品池 */
    random_case_awards: (vm) => {
      // 生成一轮奖品
      const generate_round_awards = () =>
        Array(50)
          .fill(null)
          .map(() => vm.items[parseInt(Math.random() * vm.items.length)]);

      return generate_round_awards();
    },
  },
  beforeDestory() {},
  created() {
    this.virtual_case_awards = this.random_case_awards;
  },
  mounted() {},
  methods: {
    reset() {
      this.virtual_case_awards = this.random_case_awards; //重置奖品
      this.animation_end = false;
      this.$refs.scroll.style.transition = "none";
      this.$refs.scroll.style.marginLeft = `0px`;
      this.active_item_index = 3;
      this.run_status = 0;
    },
    async start(lotteryitem) {
      this.reset();

      await this.$nextTick();
      this.$set(this.virtual_case_awards, 37, lotteryitem); //设置开奖结果
      await this.$nextTick();

      var main_roll = this.$refs.scroll;
      var award_hit_line = this.$refs.hitline;
      var award_opened = this.$refs[`roll_item_37`][0];
      award_opened.classList.remove("award_opened_item");
      var move_pixel =
        award_opened.getBoundingClientRect().left -
        award_hit_line.getBoundingClientRect().left -
        award_hit_line.getBoundingClientRect().width / 2;
      var offset_pixel = Math.ceil(
        award_opened.getBoundingClientRect().width / 2
      );
      var move_pixel_real = move_pixel + offset_pixel;

      main_roll.style.transition = this.$props.isTransition
        ? "all 4s cubic-bezier(.17,.67,.43,1)"
        : "none";
      main_roll.style.marginLeft = `-${move_pixel_real}px`;

      setTimeout(
        () => {
          this.animation_end = true;
          console.log('this.award_opened_show==',this.award_opened_show)
          if(this.award_opened_show){
            award_opened.classList.add("award_opened_item");
          }
          this.$emit("on_finished");
        },
        this.$props.isTransition ? 4500 : 100
      );
    },
  },
};
